import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { useUserStore } from '@/stores/user'
import { isAuth } from '@/const'


export default /*@__PURE__*/_defineComponent({
  __name: 'CabinetHeader',
  setup(__props, { expose: __expose }) {
  __expose();

const { $t } = useGlobal()
const store = useUserStore()
const profile = computed(() => store.profile)

const __returned__ = { $t, store, profile, ref, computed, get useGlobal() { return useGlobal }, get useUserStore() { return useUserStore }, get isAuth() { return isAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})